import { NgModule } from "@angular/core";
import { PipesModule } from "../../pipes/pipes.module";
import { SharedModule } from "../../shared";
import { CertificateFormComponent } from "./certificate-form.component";
import { CertificateListComponent } from "./certificate-list.component";
import { CertificateRoutingModule } from "./certificate-routing.module";
import { CertificateSelectionListComponent } from "./certificate-selection-list.component";
import { CertificateShowComponent } from "./certificate-show.component";
import { CertificateService } from "./crud.service";

const DIRECTIVES = [
	CertificateFormComponent,
	CertificateShowComponent,
	CertificateSelectionListComponent,
	CertificateListComponent,
];

@NgModule({
	imports: [SharedModule, PipesModule, CertificateRoutingModule],
	providers: [CertificateService],
	declarations: [...DIRECTIVES],
	exports: [...DIRECTIVES],
})
export class CertificateCrudModule {}
